<template>
  <div class="a-good-company-features">
    <Heading
      class="a-good-company-features__title"
      tag="h2"
      size="md"
      font-weight="ultra"
      text-uppercase
      spaces-bottom
      >NEU: Das Transparente Case für Dein iPhone 15
    </Heading>
    <div class="a-good-company-features__container">
      <CdnImage
        class="a-good-company-features__mobile-image"
        render-without-figure
        lazy
        src="/content/content-images/landingpages/themenwelt-refresh/d33c5fa8e88faef231d5301b2944f921/iphone-case-usps@2x.png"
        sizes="xs:320px"
        alt="Eine durchsichtige Handyhülle für das iPhone 15 von agood company"
      />
      <div class="a-good-company-features__left-section">
        <div class="a-good-company-features__left-section--top">
          <CdnImage
            class="a-good-company-features__left-section--top-image"
            render-without-figure
            lazy
            src="/content/content-images/landingpages/themenwelt-refresh/00e83919924d2b0176affbc6dd64e9eb/usp-upcycling.svg"
            alt="Ein schwarzes Symbol eines nach links gebogenen Pfeils, der einen Kreis bildet"
          />
          <Paragraph
            is-size-small
            align="center"
          >
            <strong>100 % Upcycling:</strong><br />Hergestellt aus Trinkgläsern und ausrangierten
            Süßigkeitendosen
          </Paragraph>
        </div>
        <div class="a-good-company-features__left-section--bottom">
          <CdnImage
            class="a-good-company-features__left-section--bottom-image"
            render-without-figure
            lazy
            src="/content/content-images/landingpages/themenwelt-refresh/886bc3072301c98495d38a06fdd5bd34/usp-kristallklar.svg"
            alt="Ein Symbol eines Smartphones mit zwei überlappenden Sternen auf dem Bildschirm"
          />

          <Paragraph
            is-size-small
            align="center"
          >
            Kristallklar, um Dein Handy zu betonen, nicht zu verstecken
          </Paragraph>
        </div>
      </div>
      <div class="a-good-company-features__middle-section">
        <CdnImage
          class="a-good-company-features__image"
          render-without-figure
          lazy
          src="/content/content-images/landingpages/themenwelt-refresh/d33c5fa8e88faef231d5301b2944f921/iphone-case-usps@2x.png"
          sizes="xs:100vw md:640px lg:1040px"
          alt="Eine durchsichtige Handyhülle von agood company für das iPhone 15"
        />
      </div>
      <div class="a-good-company-features__right-section">
        <div class="a-good-company-features__right-section--top">
          <CdnImage
            class="a-good-company-features__right-section--top-image"
            render-without-figure
            lazy
            src="/content/content-images/landingpages/themenwelt-refresh/832f4f24bb6f78c320a3648498e2a32f/usp-fallschutz.svg"
            alt="Ein Symbol eines schräg fallenden Smartphones"
          />
          <Paragraph
            is-size-small
            align="center"
          >
            Abgerundete Ecken für viel Schutz und Komfort.
          </Paragraph>
        </div>
        <div class="a-good-company-features__right-section--bottom">
          <CdnImage
            class="a-good-company-features__right-section--bottom-image"
            render-without-figure
            lazy
            src="/content/content-images/landingpages/themenwelt-refresh/49d8856a1c336d4fc44fadada3d50c2c/usp-abgerundete-ecken.svg"
            alt="Ein Symbol eines aufrechten Smartphones"
          />

          <Paragraph
            is-size-small
            align="center"
          >
            Geschützt bis 2 m Fallhöhe
          </Paragraph>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CdnImage from '~/components/cdn-image.vue';
import { Heading, Paragraph } from '@i22/td-longtail-vue-components';

export default {
  name: 'AGoodCompanyFeatures',
  components: {
    Heading,
    Paragraph,
    CdnImage,
  },
  props: {
    bgImageXs: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.a-good-company-features {
  margin: $grid-base * 2 0 $grid-base * 2 0;
  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    @include mq($mq-sm) {
      flex-direction: row;
      justify-content: space-around;
    }
    @include mq($mq-sm) {
      padding: 0 $grid-base * 4 0 $grid-base * 4;
    }
  }
  &__image {
    width: 180px;
    height: 320px;
    display: none;
    @include mq($mq-sm) {
      display: block;
      width: 320px;
      height: 460px;
    }
    @include mq($mq-md) {
      width: 420px;
      height: 580px;
    }
    @include mq($mq-lg) {
      width: 520px;
      height: 640px;
    }
  }
  &__mobile-image {
    display: block;
    align-self: center;
    width: 180px;
    height: 320px;
    margin-bottom: $grid-base * 3;
    @include mq($mq-sm) {
      display: none;
    }
  }
  &__middle-section {
    @include mq($mq-sm) {
      flex: 0 0 320px;
    }
    @include mq($mq-md) {
      flex-basis: 420px;
    }
    @include mq($mq-lg) {
      flex-basis: 520px;
    }
  }
  &__left-section,
  &__right-section {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    &--top,
    &--bottom {
      text-align: center;
      @include mq($mq-sm) {
        max-width: 240px;
      }
      &-image {
        @include mq(false, $mq-sm - 1) {
          width: 44px;
          height: 50px;
        }
      }
      p {
        font-size: 14px;
        line-height: 18px;
        @include mq($mq-sm) {
          font-size: 18px;
          line-height: 24px;
        }
      }
    }
    &--bottom {
      @include mq($mq-sm) {
        margin-bottom: $grid-base * 4;
      }
    }
  }
}
</style>
